import { render, staticRenderFns } from "./RegionTypeStamp.vue?vue&type=template&id=0526301e&scoped=true&lang=pug"
import script from "./RegionTypeStamp.vue?vue&type=script&lang=js"
export * from "./RegionTypeStamp.vue?vue&type=script&lang=js"
import style0 from "./RegionTypeStamp.vue?vue&type=style&index=0&id=0526301e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0526301e",
  null
  
)

export default component.exports